import { Component } from './component';
import { Label } from './label';
import { ControlButton } from './control-button';
import { ControlButtonContainer } from './control-button-container';
import { DropdownButton } from './dropdown-button';
import { Button } from './button';
import { FieldLabel } from './field-label';
import { Switch } from './switch';
import { IconSelect } from './icon-select';
import { ActionSelect } from './action-select';
import { ColorPicker } from './color-picker';
import { BeforeAfterSlider } from './before-after-slider';
import { LoadSpinner } from './load-spinner';
import { PDFView } from './pdf-view';

export class CAUI {
  static basePath = 'https://ver.caapp.com.au';

  static createId () {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < 10; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static zeroPad (num, places) {
    const zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
  }

  static scale (number, inMin, inMax, outMin, outMax) {
    return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }

  static enterFullscreen (fullscreen, el) {
    if (!CAUI.isFullscreenEnabled()) return;
    if (fullscreen) CAUI.getFullscreenMethod().call(el);
    else CAUI.getExitFullscreenMethod().call(document);
  }

  static getFullscreenMethod () {
    return (
      document.body.requestFullScreen ||
      document.body.webkitRequestFullScreen ||
      document.body.mozRequestFullScreen ||
      document.body.msRequestFullScreen
    );
  }

  static getExitFullscreenMethod () {
    return (
      document.exitFullscreen ||
      document.mozCancelFullScreen ||
      document.webkitExitFullscreen ||
      document.msExitFullscreen
    );
  }

  static isFullscreenEnabled () {
    return CAUI.getFullscreenMethod() != null;
  }

  static renderText (content) {
    let returnContent = '';
    if (Array.isArray(content)) {
      let isList = false;

      content.forEach(function (c) {
        if (c.startsWith('*')) {
          if (!isList) {
            returnContent += '<ul>';
            isList = true;
          }

          returnContent += '<li>' + c.substring(1) + '</li>';
        } else {
          if (isList) {
            returnContent += '</ul>';
            isList = false;
          }

          if (c.startsWith('h1:')) {
            returnContent +=
              '<h1 class="ca-modal_h1 pt-3">' + c.substring(3) + '</h1>';
          } else if (c.startsWith('h2:')) {
            returnContent +=
              '<h2 class="ca-modal_h2 pt-3">' + c.substring(3) + '</h2>';
          } else if (c.startsWith('h3:')) {
            returnContent +=
              '<h3 class="ca-modal_h3 pt-3">' + c.substring(3) + '</h3>';
          } else returnContent += '<p class="ca-modal_p">' + c + '</p>';
        }
      });
      return returnContent;
    } else return content;
  }
}

export {
  Component,
  Label,
  BeforeAfterSlider,
  ControlButton,
  ControlButtonContainer,
  Button,
  FieldLabel,
  Switch,
  IconSelect,
  ActionSelect,
  ColorPicker,
  DropdownButton,
  LoadSpinner,
  PDFView
};
